<template>
  <div class="bg">
    <section
      class="van-doc-demo-section"
      style="margin-left: 0.5rem; margin-right: 0.5rem"
    >
      <van-swipe
        vertical
        style="width: 9rem; height: 3.5rem; margin-top: 1.7rem"
        @change="onChange"
        :initial-swipe="this.lb"
      >
        <van-swipe-item v-for="item in list" :key="item.personal_number">
          <van-row type="flex" class="row">
            <van-col span="8">
              <van-image
                fit="fill"
                round
                width="1.8rem"
                height="1.8rem"
                style="margin: 0.7rem 2rem 0.7rem 0.83rem"
                radius
                :src="imageurl"
              />
              <!-- require('@/image/hread.png') -->
            </van-col>
            <van-col span="8">
              <van-row type="flex">
                <van-col span="24">
                  <p
                    style="
                      font-size: 0.4rem;
                      color: white;
                      margin: 1rem 0 0 0.2rem;
                    "
                  >
                    <strong>姓名:{{ item.name }}</strong>
                  </p>
                  <p
                    style="
                      font-size: 0.4rem;
                      color: white;
                      margin: 0.2rem 0 0 0.2rem;
                    "
                  >
                    <strong>{{ title }}:{{ item.personal_number }}</strong>
                  </p>
                </van-col>
              </van-row>
            </van-col>
            <van-col span="8"> </van-col>
          </van-row>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/{{ count }}</div>
        </template>
      </van-swipe>
      <van-grid :border="false" :column-num="4">
        <van-grid-item
          v-for="(item, index) in Menulist"
          :key="index"
          @click="onMenuClick(item.title)"
        >
          <van-badge v-if="item.title === 'windex'" :content="weidu">
            <van-image
              fit="fill"
              :src="item.src"
              style="width: 1.5rem; hight: 1.5rem"
            />
            <span
              style="font-size: 0.4rem; margin-top: 0.3rem; color: #333333"
              >{{ item.name }}</span
            >
          </van-badge>
          <van-badge v-else-if="item.title === 'WeChat'" :content="weidu">
            <van-image
              fit="fill"
              :src="item.src"
              style="width: 1.5rem; hight: 1.5rem"
            />
            <span
              style="font-size: 0.4rem; margin-top: 0.3rem; color: #333333"
              >{{ item.name }}</span
            >
          </van-badge>
          <div v-else-if="item.title !== 'windex' && item.title !== 'WeChat'">
            <van-image
              fit="fill"
              :src="item.src"
              style="width: 1.5rem; hight: 1.5rem"
            />
            <span
              style="font-size: 0.4rem; margin-top: 0.3rem; color: #333333"
              >{{ item.name }}</span
            >
          </div>
        </van-grid-item>
        <!-- <van-grid-item @click="onStudentadd">
          <van-badge :content="5">
            <van-image
              fit="fill"
              :src="require('@/image/xuesheng.png')"
              info="5"
              style="width: 1.5rem; hight: 1.5rem"
            />
            <span style="font-size: 0.4rem; margin-top: 0.3rem; color: #333333"
              >我的信息</span
            >
          </van-badge>
        </van-grid-item>
        <van-grid-item @click="onLocus">
          <van-image
            fit="fill"
            :src="require('@/image/guiji.png')"
            style="width: 1.5rem; hight: 1.5rem"
          />
          <span style="font-size: 0.4rem; margin-top: 0.3rem; color: #333333"
            >轨迹查询</span
          >
        </van-grid-item>
        <van-grid-item @click="onGoBack">
          <van-image
            fit="fill"
            :src="require('@/image/guiqi.png')"
            style="width: 1.5rem; hight: 1.5rem"
          />
          <span style="font-size: 0.4rem; margin-top: 0.3rem; color: #333333"
            >归寝查询</span
          >
        </van-grid-item>
        <van-grid-item @click="onStudenMesg">
          <van-image
            fit="fill"
            :src="require('@/image/weigui.png')"
            style="width: 1.5rem; hight: 1.5rem"
          />
          <span style="font-size: 0.4rem; margin-top: 0.3rem; color: #333333"
            >信息提醒</span
          >
        </van-grid-item>
        <van-grid-item @click="onLeave">
          <van-image
            fit="fill"
            :src="require('@/image/qingjia.png')"
            style="width: 1.5rem; hight: 1.5rem"
          />
          <span style="font-size: 0.4rem; margin-top: 0.3rem; color: #333333"
            >请假管理</span
          >
        </van-grid-item>
        <van-grid-item @click="onUserInfo">
          <van-image
            fit="fill"
            :src="require('@/image/shangchuan.png')"
            style="width: 1.5rem; hight: 1.5rem"
          />
          <span style="font-size: 0.4rem; margin-top: 0.3rem; color: #333333"
            >照片上传</span
          >
        </van-grid-item>
        <van-grid-item @click="onWeChat">
          <van-image
            fit="fill"
            :src="require('@/image/weixin.png')"
            style="width: 1.5rem; hight: 1.5rem"
          />
          <span style="font-size: 0.4rem; margin-top: 0.3rem; color: #333333"
            >信息提醒</span
          >
        </van-grid-item>-->
        <!-- <van-grid-item @click="onWeChatClose">
          <van-image
            fit="fill"
            :src="require('@/image/weixin.png')"
            style="width: 1.5rem; hight: 1.5rem"
          />
          <span style="font-size: 0.4rem; margin-top: 0.3rem; color: #333333"
            >清除退出</span
          >
        </van-grid-item> -->
      </van-grid>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      openid: "",
      name: "",
      xiaoqu: "",
      shenfen: "",
      weidu: "",
      imageurl: "",
      lb: 0,
      list: [],
      teacherlist: [
        {
          name: "我的信息",
          src: require("@/image/xuesheng.png"),
          title: "MyTeacher",
        },
        {
          name: "我的学生",
          src: require("@/image/wode.png"),
          title: "MyStudent",
        },
        {
          name: "轨迹查询",
          src: require("@/image/guiji.png"),
          title: "StudentLocus",
        },
        {
          name: "请假管理",
          src: require("@/image/qingjia.png"),
          title: "StudentLeave",
        },
        {
          name: "归寝查询",
          src: require("@/image/guiqi.png"),
          title: "StudentGoBack",
        },
        {
          name: "在校查询",
          src: require("@/image/zaixiao.png"),
          title: "MySchool",
        },
        {
          name: "信息提醒",
          src: require("@/image/weigui.png"),
          title: "windex",
        },
        {
          name: "清除退出",
          src: require("@/image/weixin.png"),
          title: "reset",
        },
      ],
      Parentlist: [
        {
          name: "我的信息",
          src: require("@/image/xuesheng.png"),
          title: "StudentIndex",
        },
        // {
        //   name: "照片上传",
        //   src: require("@/image/shangchuan.png"),
        //   title: "UserInfo",
        // },
        {
          name: "轨迹查询",
          src: require("@/image/guiji.png"),
          title: "StudentLocus",
        },
        {
          name: "信息提醒",
          src: require("@/image/weigui.png"),
          title: "WeChat",
        },
        {
          name: "清除退出",
          src: require("@/image/weixin.png"),
          title: "reset",
        },
      ],
      Studentlist: [
        {
          name: "我的信息",
          src: require("@/image/xuesheng.png"),
          title: "StudentIndex",
        },
        // {
        //   name: "照片上传",
        //   src: require("@/image/shangchuan.png"),
        //   title: "UserInfo",
        // },
        {
          name: "轨迹查询",
          src: require("@/image/guiji.png"),
          title: "StudentLocus",
        },
        {
          name: "信息提醒",
          src: require("@/image/weigui.png"),
          title: "WeChat",
        },
        {
          name: "清除退出",
          src: require("@/image/weixin.png"),
          title: "reset",
        },
      ],
      Menulist: [],
      studentid: "",
      current: 0,
      count: 0,
      code: "",
    };
  },
  created() {
    console.log("轮播定位：" + this.$route.query.page);
    if (
      this.$route.query.page == "undefined" ||
      this.$route.query.page == null
    ) {
      this.lb = 0;
    } else {
      this.lb = this.$route.query.page;
      var intstr = parseInt(this.$route.query.page);
      this.current = intstr;
    }
    this.onload();
  },
  methods: {
    onload() {
      this.openid = this.$route.query.openid;
      var json = window.localStorage.getItem("User");
      var jsonObj = JSON.parse(json);
      this.name = jsonObj[0]["username"];
      this.shenfen = jsonObj[0]["shenfen"];
      this.title = "学号";
      var code;
      if (jsonObj[0]["shenfen"] == "老师") {
        this.Menulist = this.teacherlist;
        code = jsonObj[0]["number"];
        this.code = code;
        this.title = "工号";
        //console.log("老师图片获取:"+     window.localStorage.getItem(this.code));
        if (
          window.localStorage.getItem(this.code) == "" ||
          window.localStorage.getItem(this.code) == "undefined" ||
          window.localStorage.getItem(this.code) == null ||
          window.localStorage.getItem(this.code) == "null"
        ) {
          this.imageurl = require("@/image/hread.png");
        } else {
          this.imageurl = window.localStorage.getItem(this.code);
        }
        this.list = [
          {
            personal_number: jsonObj[0]["number"],
            name: jsonObj[0]["username"],
          },
        ];
        this.count = 1;
      } else if (jsonObj[0]["shenfen"] == "学生") {
        this.Menulist = this.Studentlist;
        code = jsonObj[0]["number"];
        this.code = code;
        if (
          window.localStorage.getItem(this.code) == "" ||
          window.localStorage.getItem(this.code) == "undefined" ||
          window.localStorage.getItem(this.code) == null ||
          window.localStorage.getItem(this.code) == "null"
        ) {
          this.imageurl = require("@/image/hread.png");
        } else {
          this.imageurl = window.localStorage.getItem(this.code);
        }
        this.list = [
          {
            personal_number: jsonObj[0]["number"],
            name: jsonObj[0]["username"],
          },
        ];
        this.count = 1;
      } else if (jsonObj[0]["shenfen"] == "家长") {
        this.Menulist = this.Parentlist;
        code = jsonObj[0]["phone"];
        this.code = code;
        // if (this.list.length > 0) {
        //   console.log("轮播数组长度:" + this.list.length);
        //   return;
        // }
        var params_json = {
          userid: "",
          action: "getStudents",
          param1: code,
          param2: "",
          param3: "",
          param4: "",
          param5: "",
        };
        let _this = this;
        this.$http.post("/web/list", params_json).then(function (res) {
          console.log(res.data["rows"]);
          _this.list = res.data["rows"];
          _this.count = _this.list.length;

          //这里绑定第一个学生的图片操作
          console.log("第一个学生的编号：" + _this.list[0]["personal_number"]);
          var params_json1 = {
            userid: code,
            action: "getPic",
            param1: _this.list[0]["personal_number"],
            param2: "",
            param3: "",
            param4: "",
            param5: "",
          };
          _this.$http.post("/web/list", params_json1).then(function (res) {
            if (res.data["rows"].length > 0) {
              _this.imageurl = res.data["rows"][0]["pic"];
              window.localStorage.setItem(
                _this.list[0]["personal_number"],
                _this.imageurl
              );
            } else {
              _this.imageurl = require("@/image/hread.png");
            }
          });
        });
      }
    },
    //功能按钮事件
    onMenuClick(title) {
      if (title == "reset") {
        this.onWeChatClose();
      } else {
        if (this.studentid == "" || this.studentid == "undefined") {
          this.studentid = this.list[this.lb]["personal_number"];
          this.current = this.lb;
        }
        this.$router.push({
          path: title,
          query: {
            student: this.studentid,
            page: this.lb,
            xiaoqu: this.xiaoqu,
          },
        });
      }
    },
    // //添加学生按钮操作
    // onStudentadd() {
    //   this.$router.push("StudentIndex");
    // },
    // onMystudent() {
    //   this.$router.push("MyStudent");
    // },
    // //请假管理
    // onLeave() {
    //   if (this.studentid == "" || this.studentid == "undefined") {
    //     this.studentid = this.list[this.lb]["personal_number"];
    //     this.current = this.lb;
    //   }
    //   this.$router.push({
    //     path: "StudentLeave",
    //     query: {
    //       student: this.studentid,
    //       page: this.lb,
    //     },
    //   });
    // },
    // //学生轨迹查询
    // onLocus() {
    //   if (this.studentid == "" || this.studentid == "undefined") {
    //     this.studentid = this.list[this.lb]["personal_number"];
    //     this.current = this.lb;
    //   }
    //   this.$router.push({
    //     path: "StudentLocus",
    //     query: {
    //       student: this.studentid,
    //       page: this.lb,
    //     },
    //   });
    // },
    // //归寝查询
    // onGoBack() {
    //   if (this.studentid == "" || this.studentid == "undefined") {
    //     this.studentid = this.list[this.lb]["personal_number"];
    //     this.current = this.lb;
    //   }
    //   this.$router.push({
    //     path: "StudentGoBack",
    //     query: {
    //       student: this.studentid,
    //       page: this.lb,
    //     },
    //   });
    // },
    // //微信提醒
    // onWeChat() {
    //   if (this.studentid == "" || this.studentid == "undefined") {
    //     this.studentid = this.list[this.lb]["personal_number"];
    //     this.current = this.lb;
    //   }
    //   this.$router.push({
    //     path: "WeChat",
    //     query: {
    //       student: this.studentid,
    //       page: this.lb,
    //     },
    //   });
    // },
    // //未归提醒
    // onStudenMesg() {
    //   if (this.studentid == "" || this.studentid == "undefined") {
    //     this.studentid = this.list[this.lb]["personal_number"];
    //     this.current = this.lb;
    //   }
    //   this.$router.push({
    //     path: "WGmessage",
    //     query: {
    //       student: this.studentid,
    //       page: this.lb,
    //     },
    //   });
    // },
    // onClickRight() {
    //   // 危险通知
    //   this.$toast("失败文案");
    // },
    // //用户照片信息修改
    // onUserInfo() {
    //   console.log("studentid:" + this.studentid);
    //   if (this.studentid == "" || this.studentid == "undefined") {
    //     this.studentid = this.list[this.lb]["personal_number"];
    //     this.current = this.lb;
    //   }
    //   this.$router.push({
    //     path: "UserInfo",
    //     query: {
    //       student: this.studentid,
    //       page: this.lb,
    //     },
    //   });
    // },
    onChange(index) {
      this.current = index;
      this.lb = index;
      this.studentid = this.list[index]["personal_number"];
      console.log("滚动轮播家长编号：" + this.code);
      if (
        window.localStorage.getItem(this.studentid) == "" ||
        window.localStorage.getItem(this.studentid) == "undefined" ||
        window.localStorage.getItem(this.studentid) == null ||
        window.localStorage.getItem(this.studentid) == "null"
      ) {
        var params_json = {
          userid: this.code,
          action: "getPic",
          param1: this.studentid,
          param2: "",
          param3: "",
          param4: "",
          param5: "",
        };
        this.$http.post("/web/list", params_json).then(function (res) {
          console.log(res.data["rows"]);
          if (
            res.data["rows"] == "undefined" ||
            res.data["rows"] == "" ||
            res.data["rows"] == null
          ) {
            this.imageurl = require("@/image/hread.png");
          } else {
            this.imageurl = res.data["rows"][0]["pic"];
            window.localStorage.setItem(this.studentid, this.imageurl);
          }
        });
      } else {
        this.imageurl = window.localStorage.getItem(this.studentid);
      }
      console.log("轮播选择：" + this.list[index]["personal_number"]);
    },
    onWeChatClose() {
      var params_json = {
        userid: this.code,
        action: "reset",
        param1: this.shenfen,
        param2: "",
        param3: "",
        param4: "",
        param5: "",
      };
      this.$http.post("/web/save", params_json).then(function (res) {
        let obj = res.data;
        if (obj.msg == "0") {
          window.localStorage.clear();
          // this.openid = window.localStorage.getItem("openid");
          this.$notify({
            type: "success",
            message: "缓存清除成功,请重新进入.",
          });

          // setTimeout(() => {
          //   // wx.closeWindow();
          // }, 2000);
        } else {
          this.$notify({
            type: "warning",
            message: obj.msg,
          });
        }
      });
    },
  },
};
</script>

<style>
.bg {
  background: url("../image/bg.png") no-repeat;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: absolute;
}

.row {
  background: url("../image/top.png");
  background-size: contain;
  background-repeat: no-repeat;
  width: 9rem;
  height: 3.5rem;
}

.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 0.5rem;
  padding: 2px 5px;
  font-size: 0.4rem;
  color: #ffffff;
  background: rgba(0, 0, 0, 0);
}
</style>